module.exports = __webpack_public_path__ + "vividcore-small.png";